import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OfLogoComponent } from './of-logo.component';

@NgModule({
  declarations: [OfLogoComponent],
  exports: [OfLogoComponent],
  imports: [
    CommonModule
  ]
})
export class OfLogoModule { }
